import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../helpers/helpers";
import _ from "lodash";
import { Table } from "./table";
import { toJS } from "mobx";
import { TableHeader } from "./survey-summary";
import { useTranslation } from "react-i18next";
import { useTableVisibility } from "./use-table-visibility";
import { AudioAnalyticsTable } from "./audioanalyticstable";

export const SurveysByLevel2Audio = observer((props) => {
    const { surveyResponseStore, userStore } = useStore();
    const { allSurveyResponsesSummary } = surveyResponseStore;
    const { t } = useTranslation("survey_management");
    const isVisible = useTableVisibility("surveys_by_level2_audio");

    const data = useMemo(
        () => toJS(allSurveyResponsesSummary)?.["by_piv_level2_audio"] || [],
        [allSurveyResponsesSummary]
    );

    const columns = useMemo(
        () => [
            {
                Header: t("level2"),
                accessor: "piv_level2",
                Footer: t("total"),
            },
            {
                Header: t("has_audio"),
                accessor: "has audio",
                Footer: surveyResponseStore.get_total_surveys(data, "has audio"),
            },
            {
                Header: t("no_audio"),
                accessor: "no audio",
                Footer: surveyResponseStore.get_total_surveys(data, "no audio"),
            },
            {
                Header: t("total"),
                accessor: "total",
                Footer: surveyResponseStore.get_total_surveys(data, "total"),
            },
        ],
        [allSurveyResponsesSummary]
    );

    if (!isVisible) return null;
    if (!allSurveyResponsesSummary) return null;
    if (_.isEmpty(allSurveyResponsesSummary["by_piv_level2_audio"]) || userStore.is_field_worker())
        return null;

    const row_click_handler = (x) => {
        surveyResponseStore.applyFilter("piv_level2", x["piv_level2"], `Level 2: ${x["piv_level2"]}`);
    };

    return (
        <div className="w-100 flex flex-col md:w-0">
            <TableHeader title={t("level_2_audio")} />
            <Table data={data} columns={columns} onRowClick={row_click_handler} />
            {/*<AudioAnalyticsTable*/}
            {/*    data={data}*/}
            {/*    titleField="piv_level2"*/}
            {/*    titleHeader={t("level1")}*/}
            {/*    pageSize={10}*/}
            {/*    onRowClick={row_click_handler}*/}
            {/*/>*/}
        </div>
    );
});
